import '../Sass/App.scss';
import React, { useState, useEffect } from 'react';
import { Virus } from './Virus';

export function Viruses(props) {

    const [viruses, setViruses] = useState([])
    const [activeViruses, setActiveViruses] = useState([])
    const [showDestroyed, setShowDestroyed] = useState(false)
    const [dataLoaded, setDataLoaded] = useState(false)
        
    useEffect(() => {
        fetch("https://www.malwaregame.com/php/viruses.php")
            .then((res) => res.json())
            .then((json) => {
                const shuffled = json.data.sort(() => 0.5 - Math.random())
                const activeViruses = [...shuffled.slice(0,props.startingViruses)]
                const remainingViruses = [...shuffled.slice(props.startingViruses, shuffled.length)]
                setViruses(remainingViruses)
                setActiveViruses(activeViruses)
                setDataLoaded(true)
            })
    }, []) 

    function addVirus() {
        setActiveViruses([...activeViruses, viruses[0]])
        setViruses([
            ...viruses.slice(1, viruses.length)
        ])
    }

    function removeVirus(virusIndex) {
        setViruses([...viruses, activeViruses[virusIndex]])
        setActiveViruses([
            ...activeViruses.slice(0, virusIndex),
            ...activeViruses.slice(virusIndex + 1, viruses.length)
        ])
    }

    function toggleShowDestroyed() {
        setShowDestroyed(!showDestroyed)
    }

    return (
        <div style={{width: '100%', float: 'left'}}>
            <div className='white-code'>the <b>viruses</b> you're up against</div>
            <button className="cli-button-red" onClick={addVirus}>[+] add virus</button><button className="cli-button" onClick={toggleShowDestroyed} style={showDestroyed ? {backgroundColor: '#00B000', color: 'white'} : null}>show destroyed viruses</button>
            { dataLoaded && activeViruses.map((virus, index) =>
                <Virus key={index} clickHandler={props.clickHandler} virus={virus} virusIndex={index} removeVirus={removeVirus} showDestroyed={showDestroyed} type='viral' />
            )}
        </div>
    )
}
